import { ReactElement } from 'react'
import { Placeholder } from 'react-bootstrap'
import { EqualHeight, EqualHeightElement } from 'react-equal-height'
import { Picture, Post } from '@payload-types'
import Title from '@components/text/title'
import { sanitizeHtml } from '@utils/misc'
import { handleAction } from '@utils/router'

export type NewsPost = Pick<Post, 'id' | 'title' | 'description' | 'permalink'> & {
  cover?: Pick<Picture, 'url' | 'thumbnailURL'>,
  link?: string,
}

type NewsItemProps = {
  post: NewsPost,
} & ReactElement['props'] & React.HTMLAttributes<HTMLElement>;

export function NewsItemPlaceholder({ size = 8 }: { size?: number }): ReactElement {
  return (
    <Placeholder as={'div'} animation="wave" className="news-list-item news-list-item-placeholder">
      <Placeholder as={'div'} className="news-list-cover no-cover" />
      <div className="news-list-content-wrapper">
        <div className="news-list-content">
          <Placeholder as={'h3'} xs={size}>
            <Placeholder />
          </Placeholder>
          <p className="description">
            <Placeholder xs={size} />
            <Placeholder xs={size} />
            <Placeholder xs={size} />
            <Placeholder xs={size} />
            <Placeholder xs={size} />
          </p>
        </div>
      </div>
    </Placeholder>
  );
};

export default function NewsItem({ post, ...props }: NewsItemProps): ReactElement {
  const coverClass = post.cover ? 'has-cover' : 'no-cover';
  const coverUrl = (post.cover && post.cover?.url) ? (post.cover?.thumbnailURL || post.cover.url) : '/images/logo-branca.svg';

  const action = post?.link || ( post?.permalink || `/${post.id}` );

  return (
    <EqualHeight>
      <div className="news-list-item" {...props}>
        <div className={`news-list-cover ${coverClass}`} style={{ backgroundImage: `url('${coverUrl}')` }} onClick={() => handleAction({ action, target: '_blank' })}>
          <EqualHeightElement name="news-list-item-height"/>
        </div>
        <div className="news-list-content-wrapper">
          <div className="news-list-content">
            <EqualHeightElement name="news-list-item-height">
              <Title as="h3" onClick={() => handleAction({ action, target: '_blank' })}>
                {post.title}
              </Title>
              <p className="description" dangerouslySetInnerHTML={{__html: sanitizeHtml(post.description) }} />
            </EqualHeightElement>
          </div>
        </div>
      </div>
    </EqualHeight>
  );
}
